import {
  TEAM_CONSTRAINT_CODES,
  TEAM_HIDDEN_FROM_PER_TEAM_VIEW_CODES,
} from '../../constants'
import type { SchedulerConstraint } from '../../hooks/useSchedulerConstraints'

/**
 * Pure helper used by `DivisionTeamsTable` to decide which constraints
 * appear under a given team's expanded sub-table. Filters by:
 *   - explicit `team_uids` membership, OR
 *   - team-tier broadcast (`team_uids === null` and code is in
 *     `TEAM_CONSTRAINT_CODES`)
 *
 * Codes in `excludeCodes` are dropped regardless — the per-team list is
 * not the editing surface for those (e.g. `pair_matchup_count` lives in
 * Matchup Config).
 */
export const filterPerTeamConstraints = (
  constraints: SchedulerConstraint[],
  teamId: string,
  excludeCodes: readonly string[] = TEAM_HIDDEN_FROM_PER_TEAM_VIEW_CODES
): SchedulerConstraint[] => {
  const excluded = new Set(excludeCodes)
  return constraints.filter((c) => {
    if (excluded.has(c.type.code)) {
      return false
    }
    if (c.team_uids && c.team_uids.includes(teamId)) {
      return true
    }
    if (
      c.team_uids === null &&
      TEAM_CONSTRAINT_CODES.includes(
        c.type.code as (typeof TEAM_CONSTRAINT_CODES)[number]
      )
    ) {
      return true
    }
    return false
  })
}
